import { CompanyForm, CompanyFormProps } from "components";
import { Modal, ModalProps } from "features/Modal";
import { t } from "i18next";

interface CompanyModalProps
  extends Omit<ModalProps, "onChange">,
    Pick<CompanyFormProps, "onChange" | "onCancel" | "onNext" | "companyId"> {}

export const CompanyModal = ({ open, setOpen, onChange, companyId, onCancel, onNext }: CompanyModalProps) => {
  return (
    <Modal withActions={false} open={open} setOpen={setOpen}>
      <CompanyForm
        title={
          <>
            {t("roleManagement.chooseCompanyWhereTo")}{" "}
            <span className="font-bold">{t("roleManagement.manageRoles")}</span>
          </>
        }
        onChange={onChange}
        companyId={companyId}
        onCancel={(value) => {
          setOpen(false);
          onCancel(value);
        }}
        onNext={() => {
          setOpen(false);
          onNext();
        }}
        next={t("common.confirm")}
        placeholder={t("roleManagement.allCompanies")}
      />
    </Modal>
  );
};
